var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelledSlots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6779 4.11603H17.9475V3.38562C17.9475 2.76157 17.4411 2.2552 16.8171 2.2552C16.193 2.2552 15.6867 2.76157 15.6867 3.38562V4.11603H8.64333V3.38562C8.64333 2.76157 8.13696 2.2552 7.51292 2.2552C6.88887 2.2552 6.3825 2.76157 6.3825 3.38562V4.11603H5.65208C2.97647 4.11603 0.8 6.2925 0.8 8.96812V20.1331C0.8 22.8087 2.97647 24.9852 5.65208 24.9852H18.6779C21.3535 24.9852 23.53 22.8087 23.53 20.1331V8.96812C23.53 6.2925 21.3535 4.11603 18.6779 4.11603ZM5.65208 6.37687H18.6779C20.1064 6.37687 21.2692 7.53967 21.2692 8.96812V9.69853H3.06083V8.96812C3.06083 7.53967 4.22363 6.37687 5.65208 6.37687ZM18.6779 22.7244H5.65208C4.22363 22.7244 3.06083 21.5616 3.06083 20.1331V11.9594H21.2692V20.1331C21.2692 21.5616 20.1064 22.7244 18.6779 22.7244Z",
    fill: "#46565C",
    stroke: "#46565C",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55606 2.01501L20.4727 25.36",
    stroke: "#46565C",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90939 0.999984L21.8261 24.345",
    stroke: "#F5F5F5",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelledSlots);
export default __webpack_public_path__ + "static/media/cancelled_slots.89a580584b4b58df37e3ccdc261ea769.svg";
export { ForwardRef as ReactComponent };